import styled from '@emotion/styled';

export const PlayerWrapper = styled.div`
	width: 100%;
	height: 100%;
	> :last-of-type {
		width: 100%;
		height: 100%;
	}
`;
